import cf from './cf';
import i1zv3 from './i1zv3_20211024';

export default class i1zv3a extends i1zv3 {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.d_viewDefs = {
      name: '使用状況', // スタッフ用使用状況
      class: 'i1zv3a',
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
